export const Cart = () => {
  return (
    <svg viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 1H3L4.54545 9.92667C4.61196 10.2336 4.79412 10.5093 5.06003 10.7055C5.32595 10.9018 5.65869 11.006 6 11H14.5C14.8413 11.006 15.174 10.9018 15.44 10.7055C15.7059 10.5093 15.888 10.2336 15.9545 9.92667L17 4H3.56413"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="6" cy="14" r="1" fill="currentColor" />
      <circle cx="15" cy="14" r="1" fill="currentColor" />
      <path d="M10.5 6L10.5 9" stroke="currentColor" strokeLinecap="round" />
      <path d="M14 6L13.5 9" stroke="currentColor" strokeLinecap="round" />
      <path d="M7 6L7.5 9" stroke="currentColor" strokeLinecap="round" />
    </svg>
  )
}
